import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Global} from "../global";

@Component({
  selector: 'app-pdf-ficha',
  templateUrl: './pdf-ficha.component.html'
})
export class PdfFichaComponent {

  url = '';

  alturaTela;

  constructor(
    public global: Global,
    private route: ActivatedRoute
  ) {
    route.params.subscribe(params => {
      this.url = global.dominio_site+'/adm/fichas/'+params['id_ficha']+'/pdf/?tk='+localStorage.getItem('token');
    });
    this.alturaTela = window.screen.availHeight - 250;
  }

}



// WEBPACK FOOTER //
// ./src/app/fichas/pdf-ficha.component.ts